import { createBasicSelector } from 'util/redux'
import { CONTACT_CREATE_PAGE, CONTACT_EDIT_PAGE, CONTACTS_PAGE } from '../pages'

export const selectIsOnContactsPage = createBasicSelector(state =>
  [CONTACT_CREATE_PAGE, CONTACT_EDIT_PAGE, CONTACTS_PAGE].includes(
    state.location.type
  )
)
